import { useIsWeb } from '@/hooks/useIsWeb';
import type { FormOption } from '@/screens/ReportCreation/reportCreation.types';
import { FieldTitle } from '@components/FieldTitle/FieldTitle';
import { Pressable } from 'react-native';
import { SizableText, XStack, YStack } from 'tamagui';

export interface ToggleGroupFieldProps {
  label?: string;
  options: FormOption[];
  value: string | null | undefined;
  onValueChange: (value: string) => void;
  required?: boolean;
}

export const ToggleGroupField = ({
  label,
  options,
  value,
  onValueChange,
  required = false,
}: ToggleGroupFieldProps): React.ReactElement => {
  const isWeb = useIsWeb();

  return (
    <YStack gap="$2">
      <FieldTitle label={label} required={required} />

      <XStack gap="$2" flex={1}>
        {options.map((option) => {
          const isSelected = value === option.value;

          return (
            <Pressable
              key={option.value}
              onPress={() => onValueChange(isSelected ? '' : option.value)}
              style={{ flex: 1 }}
            >
              <XStack
                backgroundColor={isSelected ? '$errorBg' : 'transparent'}
                borderWidth={1}
                borderColor={isSelected ? '$brand' : '$tertiary'}
                paddingVertical="$3"
                paddingHorizontal="$1"
                alignItems="center"
                justifyContent="center"
                flex={1}
              >
                <SizableText
                  size="$2"
                  textAlign="center"
                  numberOfLines={isWeb ? 2 : 1}
                >
                  {option.label}
                </SizableText>
              </XStack>
            </Pressable>
          );
        })}
      </XStack>
    </YStack>
  );
};
